import { useQuery, useMutation } from "@tanstack/react-query";
import { GET, POST, PUT, DELETE } from "../services/index";

// หัวข้อเคสผิดพลาด (master data) — company มาจาก header ใน services อัตโนมัติ
// เดิม hardcode ใน AuditCase / AuditCaseReport / EmployeeCaseReport ตอนนี้ย้ายมาที่นี่ที่เดียว

// หัวข้อที่เปิดใช้งาน — cache key เดียวสำหรับทุกที่ที่ใช้
// fetcher ต้องคืน "rows ดิบ" แล้วค่อยแปลงร่างใน select ไม่งั้นจะแชร์ cache กันไม่ได้
// (หน้าสรุปใช้ทั้ง 2 แบบพร้อมกัน ถ้าแยก key จะยิง API ซ้ำ)
const useEnabledTopics = (selectFn) =>
  useQuery(
    ["errorTopics", "enabled"],
    async () => {
      const { result } = await GET(`/api/v1/errorTopic?enable=1`);
      return result || [];
    },
    { select: selectFn }
  );

// ใช้กับ dropdown ที่เก็บค่าเป็น "ข้อความ" — AuditInput.auditRemark
export const useErrorTopicOptions = () => {
  const { data = [], isLoading } = useEnabledTopics((rows) =>
    rows.map((r) => ({ label: r.topic, value: r.topic }))
  );
  return { options: data, isLoading };
};

// ใช้กับ Report (Panel) — คอลัมน์ reportCaseOutput.audit_remark_type เป็น int
// และหน้าตรวจเคสเอง (CaseAudit.error_topic_id) จึงต้องได้ value เป็น id
export const useErrorTopicIdOptions = () => {
  const { data = [], isLoading } = useEnabledTopics((rows) =>
    rows.map((r) => ({ label: r.topic, value: r.id }))
  );
  return { options: data, isLoading };
};

// ใช้กับหน้า admin — เห็นทุกหัวข้อรวมที่ปิดใช้งาน
export const useErrorTopics = () => {
  return useQuery(["errorTopics", "all"], async () => {
    const { result } = await GET(`/api/v1/errorTopic`);
    return result || [];
  });
};

export const useCreateErrorTopic = () => {
  return useMutation({
    mutationFn: async (payload) => await POST(`/api/v1/errorTopic`, payload),
  });
};

export const useUpdateErrorTopic = () => {
  return useMutation({
    mutationFn: async ({ id, ...payload }) =>
      await PUT(`/api/v1/errorTopic/${id}`, payload),
  });
};

export const useDeleteErrorTopic = () => {
  return useMutation({
    mutationFn: async (id) => await DELETE(`/api/v1/errorTopic/${id}`),
  });
};
